import React from 'react';
import './App.css';
import AppRouting from './AppRouting.js';
import { Provider } from 'react-redux';
import { store } from './redux-store/store';
import { AuthProvider } from './hooks/AuthContext.js';
import { ThemeProvider } from '@mui/material';
import { appTheme } from './shared/theme/muitheme.js';
import InstallPrompt from './components/PWA/InstallPrompt.jsx';

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider theme={appTheme}>
          <AppRouting />
          <InstallPrompt />
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  )
}

export default App;